import map from "lodash/fp/map";
import assign from "lodash/fp/assign";
import flow from "lodash/fp/flow";
import moment from "moment";
import constants from "../../core/constants";
import { formatKey } from "../../core/utils";

class FinesReimbursementsPageTransform {
  constructor() {
    "ngInject";

    this.fields = [
      { title: "Captain Name", name: "captainName" },
      { title: "Reason", name: "reason" },
      { title: "Date", name: "date" },
      { title: "Amount", name: "amount" },
      { title: "Status", name: "status" },
    ];

    this.filters = [
      {
        name: "captain",
        title: "Captain",
        icon: "person",
        resource: "Captain",
        hasExact: true,
        exactFields: ["name", "phone"],
        size: 25,
      },
      {
        name: "status",
        title: "Status",
        icon: "format_strikethrough",
        list: "finesReimbursementsStatus",
        multiple: true,
      },
      {
        name: "reason",
        title: "Reason",
        icon: "directions_car",
        list: true,
        listOptions: [],
        multiple: true,
      },
      { name: "date", title: "Select date", icon: "date_range", isDate: true },
    ];
  }

  justify(data) {
    const getSource = (item) => {
      item = assign({ _id: item._id }, item._source);

      return item;
    };

    const format = (item) => {
      item.captainName = item.captain.name;
      item.reason = item.reason && item.reason.title_i18n.en;
      item.date = moment(item.date).format(constants.dateFormat);
      item.amount = `${item.amount / constants.currencyBy} ${item.currency}`;
      item.status = formatKey(item.status);

      return item;
    };

    return map(flow([getSource, format]))(data);
  }
}

export default FinesReimbursementsPageTransform;



// WEBPACK FOOTER //
// ./src/pages/finesReimbursements/finesReimbursements.transforms.js